var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.43 -0.43 12 12",
    id: "Target--Streamline-Flex",
    height: 12,
    width: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Target Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target--shop-bullseye-arrow-target"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.335612428571428 5.574201371428571c0 3.0527737714285714 -1.7172310000000002 4.769925199999999 -4.769957028571429 4.769925199999999C2.512889585714286 10.344126571428571 0.7957142857142857 8.626975142857143 0.7957142857142857 5.574201371428571c0 -3.0527578571428573 1.7171753 -4.769941114285714 4.769941114285714 -4.769941114285714",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.8025176571428565 3.1731414714285715c-1.1074671857142857 0.2513422714285714 -1.7171832571428574 1.0888713428571428 -1.7171832571428574 2.4006143 0 1.5874340857142857 0.8929346571428571 2.480384657142857 2.480368742857143 2.480384657142857 1.3761480714285714 0 2.2303632714285717 -0.6710656428571429 2.433373857142857 -1.883893357142857",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 271",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.565727014285714 5.5737637285714285 1.6530884714285714 -1.6530805142857143",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 274",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.218051600000001 3.9221632428571427 -0.09902664285714285 -0.32111845714285714c-0.17382378571428572 -0.5636362571428571 -0.02164342857142857 -1.1771876714285714 0.3954222571428571 -1.5942772285714284l1.210798642857143 -1.2108623 0.3816245714285714 1.2373834571428572 1.2373357142857142 0.38159274285714284 -1.2107588571428571 1.2108384285714286c-0.4171134285714286 0.4170975142857143 -1.0306887142857142 0.5692858285714285 -1.5943170142857142 0.39546204285714287l-0.3210786714285714 -0.09901868571428571Z",
    strokeWidth: 0.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGoal);
export default __webpack_public_path__ + "static/media/active-goal.c866ce8cbc93aeb0a6e7c543d21cd821.svg";
export { ForwardRef as ReactComponent };